/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Generate_RetryInputs */



/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Meeting_Report_Generate_RetryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_generate_retry = /** @type {((inputs?: Meeting_Report_Generate_RetryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Generate_RetryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opnieuw proberen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réessayer")
	return /** @type {LocalizedString} */ ("Try again")
});